import styled from '@benzinga/themetron';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import React from 'react';
import { NO_VALUE } from '../../Ticker';
import { CustomCellRendererProps } from 'ag-grid-react';
import { comparators, formatCellValueOrDefault, getCellValueOrDefault } from '../helpers';
import { isNil } from '@benzinga/utils';
const ChangeRenderer: React.FC<CustomCellRendererProps> = props => {
  const val = props.value;
  const valFormat = props.valueFormatted;
  if (isNil(val)) {
    return <Neutral>{NO_VALUE}</Neutral>;
  } else if (val === 0) {
    return <Neutral>{valFormat}</Neutral>;
  } else if (val > 0) {
    return <Positive>{valFormat}</Positive>;
  } else {
    return <Negative>{valFormat}</Negative>;
  }
};

const Neutral = styled.div`
  padding: 0 6px;
`;

const Positive = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.positive} !important;
  fill: ${({ theme }) => theme.colors.statistic.positive} !important;
`;

const Negative = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.negative} !important;
  fill: ${({ theme }) => theme.colors.statistic.negative} !important;
`;

export const ChangeColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: ChangeRenderer,
  cellStyle: { textAlign: 'right' },
  filter: 'agNumberColumnFilter',
  valueFormatter: colDef.valueFormatter ?? formatCellValueOrDefault,
  valueGetter: colDef.valueGetter ?? getCellValueOrDefault,
  ...colDef,
  ...absColDef({
    ...colDef,
    advancedSort: {
      ...colDef.advancedSort,
      absSort: true,
    } as AdvancedColDef['advancedSort'],
    comparator: colDef.comparator ?? comparators.numberComparator,
  }),
});
